import { useRef } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import i18n from "i18next";

import { getBaseImageURL } from "../../../../../../helpers";
import { formatCurrency } from "../../../../../../helpers/numberFormat";
import { decryptedData } from "../../../../../../helpers/encryptDecryptData";
import { getYouTubeThumbnail } from "../../../../../../helpers/getYouTubeThumbnail";

import "./SecondaryMarketCard.scss";

const SecondaryMarketCard = ({
  projectData,
  taxonomy,
  isEncrypted,
  itemKey,
}) => {
  const globalImagePath = useRef(getBaseImageURL());
  const { siteSettings } = useSelector((state) => state.siteSettings);

  const { currentUser } = useSelector((state) => state.getCurrentUser);

  return (
    <Card className="secondary-market-project-card" key={itemKey}>
      <Card.Img
        variant="top"
        src={
          projectData?.campaignId?.uploadType === "image"
            ? `${globalImagePath.current}${projectData?.campaignId?.campaignImageURL}`
            : getYouTubeThumbnail(projectData?.campaignId?.campaignVideoURL)
        }
      />

      <Card.Body className="project-card-body">
        <Card.Body className="card-company-logo-wrapper text-center p-0">
          <img
            src={`${globalImagePath.current}${projectData?.campaignId?.companyId?.companyLogo}`}
            alt=""
          />
        </Card.Body>
        <Card.Title className="mt-3">
          <Link
            to={`/campaign-detail-page/${projectData?.campaignId?.companyId?.companySlug}`}
          >
            {siteSettings?.projectScriptType === 0
              ? isEncrypted
                ? decryptedData(projectData?.campaignId?.companyId?.companyName)
                : projectData?.campaignId?.companyId?.companyName
              : isEncrypted
              ? decryptedData(
                  localStorage.getItem("i18nextLng") === "ar"
                    ? projectData?.campaignId?.propertyNameAr
                    : projectData?.campaignId?.propertyName
                )
              : localStorage.getItem("i18nextLng") === "ar"
              ? projectData?.campaignId?.propertyNameAr
              : projectData?.campaignId?.propertyName}
          </Link>
        </Card.Title>
        <Card.Text className="seller-name-wrap mb-1">
          {isEncrypted
            ? decryptedData(projectData?.user?.firstName)
            : projectData?.user?.firstName}{" "}
          {isEncrypted
            ? decryptedData(projectData?.user?.lastName)
            : projectData?.user?.lastName}
        </Card.Text>
        <Card.Text className="seller-location-wrap">
          {isEncrypted
            ? decryptedData(projectData?.campaignId?.companyId?.address)
            : projectData?.campaignId?.companyId?.address}{" "}
        </Card.Text>
        <hr />
        <Row className="align-items-between mb-4">
          <Col>
            {" "}
            <strong>
              {formatCurrency(
                projectData?.sellingPricePerShare ?? 0,
                siteSettings.currencySymbolSide,
                projectData?.campaignId?.equityCurrencySymbol,
                projectData?.campaignId?.equityCurrencyCode,
                siteSettings.decimalPoints
              )}
            </strong>{" "}
          </Col>
          <Col xs="auto">
            <strong>{projectData?.numberOfShareAvailable} {i18n.t("secondaryMarket.card.shares")}</strong>
          </Col>
        </Row>
        <Card.Body className="p-0 secMarket-btn-wrap">
          <Link
            to={`/campaign-detail-page/${projectData?.campaignId?.companyId?.companySlug}`}
            className="btn secondary-btn rounded-pill"
          >
            {i18n.t("secondaryMarket.card.projectDetail", {
              value: taxonomy?.projectSingular,
            })}
          </Link>
          <Link
            to={
              !currentUser ||
              (currentUser?.id !== projectData?.user?._id &&
                currentUser?.id !== projectData?.campaignId?.user?._id)
                ? `/secondary-market/buyer-steps/share-details/${projectData?.id}`
                : null
            }
            className={
              "btn secondary-btn rounded-pill" +
              (currentUser &&
              (currentUser?.id === projectData?.user?._id ||
                currentUser?.id === projectData?.campaignId?.user?._id)
                ? " sm-link-disabled"
                : "")
            }
          >
            {i18n.t("secondaryMarket.card.buyShares")}
          </Link>
        </Card.Body>
      </Card.Body>
    </Card>
  );
};
export default SecondaryMarketCard;
